import { apiContactSlice } from "@/redux/app/api/apiSlice";

export const contactSlice = apiContactSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllContact: builder.query({
      query: ({ params, lang }) => ({
        url: `/api/dashboard/contact`,
        params: { ...params },
        headers: {
          "Accept-Language": lang,
        },
      }),
      providesTags: ["Contact"],
      forceRefetch: ({ currentArg, previousArg }) => {
        return (
          JSON.stringify(currentArg?.params?.page) !==
            JSON.stringify(previousArg?.params?.page) ||
          JSON.stringify(currentArg?.params?.limit) !==
            JSON.stringify(previousArg?.params?.limit)
        );
      },
    }),
    // getSpecificAds: builder.query({
    //   query: (adId) => ({
    //     url: `/api/dashboard/tarwij/${adId}`,
    //   }),
    //   providesTags: ["Ads"],
    // }),
    createContact: builder.mutation({
      query: (contact) => ({
        url: "/api/contact",
        method: "POST",
        body: contact,
        formData: true,
      }),
      invalidatesTags: ["Contact"],
    }),
    updateContact: builder.mutation({
      query: (id) => ({
        url: `/api/dashboard/contact/answer/${id}`,
        method: "POST",
        body: "",
        // extraOptions: { skipToast: true }, // disable deafult toast
      }),
      invalidatesTags: ["Contact"],
    }),
    // switchAds: builder.mutation({
    //   query: (AdsItem) => ({
    //     url: `/api/dashboard/general-faculty/switch`,
    //     method: "POST",
    //     body: AdsItem,
    //     formData: true,
    //   }),
    //   invalidatesTags: ["Ads"],
    // }),
    deletecontact: builder.mutation({
      query: (id) => ({
        url: `/api/dashboard/contact/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Contact"],
    }),
  }),
});

export const {
  useCreateContactMutation,
  useGetAllContactQuery,
  useDeletecontactMutation,
  useUpdateContactMutation,
} = contactSlice;
